/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchCategoryRowFeaturedStoreRequest,
    BatchSaveCategoryRowFeaturedStoreResponse,
} from '../models';

export interface CategoryRowFeaturedStoreApiControllerBatchSaveCategoryRowFeaturedStoresRequest {
    categoryRowId: string;
    batchCategoryRowFeaturedStoreRequest: BatchCategoryRowFeaturedStoreRequest;
}

/**
 * 
 */
export class CategoryRowFeaturedStoreApi extends runtime.BaseAPI {

    /**
     */
    async categoryRowFeaturedStoreApiControllerBatchSaveCategoryRowFeaturedStoresRaw(requestParameters: CategoryRowFeaturedStoreApiControllerBatchSaveCategoryRowFeaturedStoresRequest): Promise<runtime.ApiResponse<BatchSaveCategoryRowFeaturedStoreResponse>> {
        if (requestParameters.categoryRowId === null || requestParameters.categoryRowId === undefined) {
            throw new runtime.RequiredError('categoryRowId','Required parameter requestParameters.categoryRowId was null or undefined when calling categoryRowFeaturedStoreApiControllerBatchSaveCategoryRowFeaturedStores.');
        }

        if (requestParameters.batchCategoryRowFeaturedStoreRequest === null || requestParameters.batchCategoryRowFeaturedStoreRequest === undefined) {
            throw new runtime.RequiredError('batchCategoryRowFeaturedStoreRequest','Required parameter requestParameters.batchCategoryRowFeaturedStoreRequest was null or undefined when calling categoryRowFeaturedStoreApiControllerBatchSaveCategoryRowFeaturedStores.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/category-rows/{categoryRowId}/featured-stores:batch`.replace(`{${"categoryRowId"}}`, encodeURIComponent(String(requestParameters.categoryRowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchCategoryRowFeaturedStoreRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async categoryRowFeaturedStoreApiControllerBatchSaveCategoryRowFeaturedStores(requestParameters: CategoryRowFeaturedStoreApiControllerBatchSaveCategoryRowFeaturedStoresRequest): Promise<BatchSaveCategoryRowFeaturedStoreResponse> {
        const response = await this.categoryRowFeaturedStoreApiControllerBatchSaveCategoryRowFeaturedStoresRaw(requestParameters);
        return await response.value();
    }

}
